module.exports = __webpack_public_path__ + "static/media/se.e3306fed.svg";